<div class="container card" *ngIf="charge">
  <div class="close" (click)="dialogRef.close()">
    <img src="assets/icons/news/close.svg" alt="close modal" />
  </div>
  <div class="header">
    <h1>Información del cargo</h1>
    <p class="id-charge" (click)="copyChargeId()">ID: {{ charge.id }}</p>
    <p class="id-copied-message" *ngIf="successCopy">¡ID copiado!</p>
    <div class="section" *ngIf="charge.status === 'NEW'">
      <p class="section-name">Link de pago</p>
      <div class="payment-url">
        <div class="url">{{ charge.hosted_url }}</div>
        <button (click)="copyUrl()" class="copy">
          <img *ngIf="!successCopyUrl" src="assets/icons/news/copy_violet.svg" />
          <img *ngIf="successCopyUrl" class="success" src="assets/icons/checked-onboarding.svg" />
        </button>
      </div>
    </div>
  </div>
  <div class="details">
    <div class="info-item row amount">
      <div class="col">
        <p class="title">Monto</p>
        <div class="content">
          <div class="text amount">
            {{ +charge.price.amount | currency: charge.price.currency }}
            <div class="fee-tooltip">
              <img *ngIf="+charge.fee" src="assets/icons/info.svg" alt="info" class="fee-img" />
              <div class="tooltip-content">
                <div [outerHTML]="charge | getConvertedChargeFee"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <p class="title">Estado Actual</p>
        <div class="content">
          <p class="text status" [class]="charge.status">{{ statusText[charge.status] }}</p>
        </div>
      </div>
    </div>

    <div class="info-item">
      <p class="title">Cliente</p>
      <div *ngIf="charge.metadata?.client" class="content customer-data">
        <p class="text">
          {{ charge.metadata.client.first_name || '-' }}
          {{ charge.metadata.client.last_name || '-' }}
        </p>
        <!-- <p class="text">DNI/CUIT: {{ charge.metadata.client.id || '-' }}</p> -->
        <p class="text">Dirección: {{ charge.metadata.client.address_1 || '-' }}</p>
        <p class="text">Ciudad: {{ charge.metadata.client.city || '-' }}</p>
        <p class="text">Código postal: {{ charge.metadata.client.postcode || '-' }}</p>
        <p class="text">Teléfono: {{ charge.metadata.client.phone || '-' }}</p>
        <p class="text">Email: {{ charge.metadata.client.email || '-' }}</p>
      </div>
      <div *ngIf="!charge.metadata?.client" class="content"><p class="text">-</p></div>
    </div>
    <!-- LISTADO DE ITEMS -->
    <div *ngIf="charge.metadata?.items?.length" class="info-item">
      <p class="title">Ítems</p>
      <div class="content multiple-items metadata-items scrollable">
        <table>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Descripcion</th>
              <th>Cantidad</th>
              <th>Precio</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of charge.metadata.items">
              <td>{{ item.name }}</td>
              <td>{{ item.desc }}</td>
              <td class="centered-text">{{ item.quantity }}</td>
              <td>{{ item.price }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- HISTORIAL DE ESTADOS -->
    <!-- <div class="info-item">
      <p class="title">Historial de estados</p>
      <div class="content multiple-items scrollable">
        <div class="item" *ngFor="let timelineItem of charge.timeline">
          <p>{{ statusText[timelineItem.status] }}</p>
          <p>{{ timelineItem.time | date: 'dd/MM/YYYY HH:mm' }}</p>
        </div>
      </div>
    </div> -->

    <!-- HISTORIAL DE PAGOS -->
    <div class="info-item" *ngIf="charge?.payments">
      <p class="title">Historial de pagos</p>
      <div class="content multiple-items scrollable">
        <p class="empty-list" *ngIf="!charge.payments.length">No se han registrado pagos aún</p>
        <div class="item" *ngFor="let payment of charge.payments">
          <p>{{ payment.value.human | currency: payment.coin }}</p>
          <p>{{ payment.status }}</p>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="
      !data.isFromPayment &&
      (charge.status === 'UNDERPAID' ||
        charge.status === 'OVERPAID' ||
        charge.status === 'DELAYED' ||
        charge.status === 'MULTIPLE' ||
        charge.status === 'UNRESOLVED')
    "
    class="button-container"
  >
    <button (click)="resolveCharge()" mat-button class="td-btn primary">Resolver</button>
  </div>
  <div
    *ngIf="
      !data.isFromPayment &&
      (charge.status === 'COMPLETED' ||
        charge.status === 'RESOLVED' ||
        charge.status === 'UNDERPAID' ||
        charge.status === 'OVERPAID' ||
        charge.status === 'DELAYED')
    "
    class="button-container"
  >
    <button [disabled]="true" (click)="refundCharge()" mat-button class="td-btn primary">
      Reembolsar
    </button>
  </div>
</div>
